import type { ApiResponse } from '@gry-dmitrij/api-request'
import request from './request'

export interface SpeechToken {
  token: string
  region: string
}

export const getSpeechToken = async (): Promise<SpeechToken> => {
  const { data }: ApiResponse<SpeechToken> = await request('get', '/api/services/speech_to_text')
  return data
}
